let revealing = false;

// The same static cover survives React mounting, font loading and route loading.
// It is dismissed only once; ordinary navigation keeps the surrounding shell.
export const completeStartup = () => {
  if (revealing || document.documentElement.dataset.appReady === 'true') return;
  revealing = true;
  Promise.resolve(window.__blogPrepareFont?.(document.getElementById('root')?.textContent) || window.__blogFontReady).finally(() => {
    window.requestAnimationFrame(() => {
      document.documentElement.dataset.appReady = 'true';
      const cover = document.getElementById('boot-screen');
      if (!cover) return;
      cover.setAttribute('aria-hidden', 'true');
      window.setTimeout(() => cover.remove(), 360);
    });
  });
};
